var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_vm._m(0),_c('ClientLogs')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex__between pt-3"},[_c('div',{staticClass:"form-group"},[_c('h4',[_vm._v("All Request Logs")])])])
}]

export { render, staticRenderFns }